import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class clockService {    
  async fetch(params) {
    try {      
      const result = await client.get('clockregister/index', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async reprocess(id) {
    try {      
      const result = await client.post('clockregister/reprocess', { registerId: id });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async create(payload) {
    try {      
      const result = await client.post('clockregister/create', payload);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new clockService();
